import { useMemo } from 'react'
import * as Texts from '../../intl'
import { Footer } from './components/Footer'
import FormContent from './FormContent'
import { form } from './formState'
import { useOnSubmit } from './hooks/useOnSubmit'
import { Props, SimulationFormValues } from './typings'
import { getFormInitialValues } from './utils'
import { FormConfig } from '@workwave-tidal/core/form'

export function SingleEdit(props: Props) {
  const { today, simulation, calendarSelection, isSelectingArchivedDate } = props
  const initialValues = useMemo<SimulationFormValues>(
    () => getFormInitialValues(simulation, today, calendarSelection, isSelectingArchivedDate),
    [simulation, today, calendarSelection, isSelectingArchivedDate],
  )

  const onSubmit = useOnSubmit()

  const config = useMemo<FormConfig<SimulationFormValues>>(
    () => ({
      id: 'simulationForm',
      initialValues: initialValues,
    }),
    [initialValues],
  )

  return (
    <form.Form
      config={config}
      title={Texts.getFormTitleText()}
      footer={<Footer />}
      onSubmit={onSubmit}
      disableScroll={false}
      requireTransaction={false}
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
    >
      <FormContent {...props} initialValues={initialValues} />
    </form.Form>
  )
}
